import Vue from "vue";
import Axios from "axios";

const token = localStorage.getItem("token");

Axios.defaults.headers.common = {
  "Cache-Control": "no-cache",
  Pragma: "no-cache",
  Expires: "0",
};

if (token) {
  Axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

Vue.prototype.$axios = Axios;
